import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
    content: {
        paddingHorizontal: 25,
        width: '100%',
        maxWidth: 1170,
        marginHorizontal: 'auto'
    },
    title: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 20
    },
    iconSelect: {
        width: 20,
        height: 20
    },
    contentSelect: {
        alignSelf: 'center',
        width: '40%',
        textAlign: 'center',
        alignItems: 'center'
    },
    dropdown: {
        width: '100%',
        height: 30,
        marginTop: 15,
        alignSelf: 'center',
    },
    textAmount: {
        fontSize: 14,
        color: '#A0A0A0',
        fontWeight: 'bold',
        marginTop: 35,
        textAlign: 'left'
    },
    price: {
        textAlign: 'center',
        fontSize: 12,
        marginTop: 15
    },
    contentDropdowns: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    action_buttons_container: {
        paddingHorizontal: "30%",
        marginTop: 15
    },
    action_button: {
        padding: 10,
        borderRadius: 20,
    },
    action_button_text: {
        textTransform: "uppercase",
        fontWeight: "bold",
        color: "#FFF",
        textAlign: 'center'
    },
    contentBtn: {
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20,
        marginBottom: 10
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    },
    numberInput: {
        flex: 1,
        backgroundColor: "#f1f1f1",
        borderWidth: 1,
        borderColor: "#ccc"
    },
    contentPurchase: {
        backgroundColor: "#f1f1f1",
        paddingHorizontal: 0,
        marginTop: 20
    },
    titlePurchase: {
        textAlign: 'center',
        marginBottom: 20,
    },
    contentPurchaseAmount: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
});

export default styles;
